import { db, FirebaseTimestamp } from "../../firebase";
import { push } from "connected-react-router";
import { fetchMyOpusesAction, deleteOpusAction, selectedOpusAction, fetchSelectedOpusAction } from "./actions";

const opesesRef = db.collection("opuses");

export const deleteOpus = (id, uid) => {
  return async (dispatch, getState) => {
    opesesRef
      .doc(id)
      .delete()
      .then(() => {
        const prevOpuses = getState().opuses.list;
        const nextOpuses = prevOpuses.filter((opus) => opus.id !== id);
        dispatch(deleteOpusAction(nextOpuses));
      });
    dispatch(push("/organizer/" + uid));
  };
};

export const selectedOpusDetail = (id) => {
  const opusID = id;
  console.log(opusID);
  return async (dispatch) => {
    opesesRef
      .doc(id)
      .get()
      .then((snapshot) => {
        const data = snapshot.data();
        console.log(data);
        dispatch(selectedOpusAction(data));
      });
  };
};

export const fetchMyOpuses = (state) => {
  const uid = state;
  return async (dispatch) => {
    opesesRef
      .orderBy("updated_at", "desc")
      .get()
      .then((snapshots) => {
        const opusList = [];
        snapshots.forEach((snapshot) => {
          const opus = snapshot.data();
          if (uid === opus.uid) {
            opusList.push(opus);
          }
        });
        dispatch(fetchMyOpusesAction(opusList));
      });
  };
};
export const fetchMySoldOpuses = (state) => {
  const uid = state;
  return async (dispatch) => {
    opesesRef
      .where("sold", "==", true)
      .get()
      .then((querySnapshot) => {
        const opusList = [];
        querySnapshot.forEach((snapshot) => {
          const opus = snapshot.data();
          if (uid === opus.uid) {
            opusList.push(opus);
          }
        });
        dispatch(fetchMyOpusesAction(opusList));
      });
  };
};

export const fechSelectedOpus = (state) => {
  return async (dispatch) => {
    await opesesRef
      .doc(state)
      .get()
      .then((snapshot) => {
        const data = snapshot.data();
        dispatch(fetchSelectedOpusAction(data));
      });
  };
};

export const saveOpus = (id, uid, images, name, description, size, price) => {
  return async (dispatch) => {
    const timestamp = FirebaseTimestamp.now();

    const data = {
      uid: uid,
      images: images,
      name: name,
      description: description,
      size: size,
      price: price,
      updated_at: timestamp,
    };

    if (id === "") {
      const ref = opesesRef.doc();
      id = ref.id;
      data.id = id;
      data.created_at = timestamp;
    }
    return opesesRef
      .doc(id)
      .set(data, { merge: true })
      .then(() => {
        dispatch(push("/organizer/" + uid));
      })
      .catch((error) => {
        throw new Error(error);
      });
  };
};

export const soldOpus = (id) => {
  return async (dispatch) => {
    const data = {
      sold: true,
    };

    return opesesRef
      .doc(id)
      .set(data, { merge: true })
      .then()
      .catch((error) => {
        throw new Error(error);
      });
  };
};
